import React from 'react';
export var FontsContext = /*#__PURE__*/React.createContext({});
export var FontsProvider = FontsContext.Provider;